module.exports = __webpack_public_path__ + "static/media/worldisflat.e1459074.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/worldisflat.png
// module id = 337
// module chunks = 0